// extracted by mini-css-extract-plugin
export var ceTestimonial = "Testimonial-module--ce-testimonial--1fbc1";